import {
    ConversationContent,
    ConversationError,
    ConversationInput,
} from "@/components/ai/chat/AgentExecutionConversation";
import type { NewPendingMessage } from "@/components/ai/chat/ChatInput";
import { cn } from "@/components/podkit/lib/cn";
import type { FollowModeState } from "@/hooks/use-follow-mode";
import type { Message } from "@/hooks/use-stream-conversation";
import type { PlainAgentExecution } from "@/queries/agent-queries";
import type { FC } from "react";

export type ConversationTabPanelProps = {
    error?: Error | null;
    loadingMessage?: string | null;
    messages: Message[];
    agentExecution: PlainAgentExecution | null;
    environmentId?: string;
    followMode?: FollowModeState;
    onNewMessage: (message: NewPendingMessage, messages: Message[]) => void;
    isHidden: boolean;
};

export const ConversationTabPanel: FC<ConversationTabPanelProps> = ({
    error,
    loadingMessage,
    messages,
    agentExecution,
    environmentId,
    followMode,
    onNewMessage,
    isHidden,
}) => {
    return (
        <div
            id="conversation-panel"
            role="tabpanel"
            aria-labelledby="conversation-tab"
            className={cn(
                "flex min-h-0 flex-1 flex-col",
                isHidden && "hidden"
            )}
        >
            <ConversationError error={error ?? undefined} loadingMessage={loadingMessage ?? undefined} />
            <ConversationContent messages={messages} agentExecution={agentExecution} environmentId={environmentId} />
            <ConversationInput
                hasMessages={messages.length > 0}
                agentExecution={agentExecution}
                onNewMessage={(message) => onNewMessage(message, messages)}
                followMode={followMode}
                messages={messages}
                environmentId={environmentId}
            />
        </div>
    );
};
